// src/shared/components/MarkdownRenderer/MarkdownRenderer.tsx
import { marked } from 'marked';
import { useMemo } from 'react';

import { logError } from '@shared/utils/logError';

import styles from './MarkdownRenderer.module.scss';

interface MarkdownRendererProps {
  content: string;
  className?: string;
  options?: {
    breaks?: boolean; // Convert \n to <br>
    gfm?: boolean; // GitHub Flavored Markdown
    sanitize?: boolean; // Sanitize HTML
  };
}

export function MarkdownRenderer({
  content,
  className,
  options = { breaks: true, gfm: true, sanitize: false },
}: MarkdownRendererProps) {
  const htmlContent = useMemo(() => {
    try {
      const mergedOptions = {
        breaks: options.breaks ?? true,
        gfm: options.gfm ?? true,
      };

      marked.setOptions(mergedOptions);

      return marked.parse(content);
    } catch (error) {
      logError({ message: 'Error parsing markdown', error });
      return content;
    }
  }, [content, options]);

  return (
    <div
      className={`${styles.markdownContent} ${className || ''}`}
      data-testid='markdown-renderer'
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
